import React from 'react';

export const HeaderPaperComponent = () => {
    return (
        <div
            className='header_paper2'
            style={{ display: "flex", justifyContent: "flex-end", backgroundColor: "#284945" }}
        >
        </div>
    );
};
